import { produce } from 'immer';

import {
  DOCUMENT__INITIALIZE,
  DOCUMENT_ATTACHMENTS__FETCH_FAILURE,
  DOCUMENT_ATTACHMENTS__FETCH_SUCCESS,
} from '@app/store/actionTypes';
import { DocumentAttachmentsAction } from '@app/store/document/attachments/actions';

import { DocumentAction } from '../actions';

export interface DocumentAttachment {
  attachmentId: string;
  attachmentType: string;
  documentId: string;
  fileExtension: string | null;
  fileName: string | null;
  participantName: string;
  participantSigningOrder: number;
}

export type DocumentAttachmentsState = DocumentAttachment[];

const initialState: DocumentAttachmentsState = [];

export default function reducer(
  state: DocumentAttachmentsState = initialState,
  action: DocumentAction | DocumentAttachmentsAction
) {
  switch (action.type) {
    /*
     * DOCUMENT_ATTACHMENTS__FETCH_REQUEST 액션이 디스패치 되었을 때
     * initialiState를 리턴하고 SUCCESS시 state를 set해주기때문에
     * 슬랙링크처럼 깜박거리는 현상이 일어나서 REQUEST케이스를 제거하였습니다.
     * .
     * 관련 스레드
     * https://modusign.slack.com/archives/C022S16PU15/p1670311861018169
     */

    case DOCUMENT_ATTACHMENTS__FETCH_SUCCESS:
      return produce(state, () => {
        const { attachments } = action.payload;
        return attachments.map((attachment) => {
          const {
            attachmentId,
            documentId,
            participant: { name: participantName, signingOrder: participantSigningOrder },
            request: { attachmentType },
            file,
          } = attachment;
          return {
            attachmentId,
            attachmentType,
            documentId,
            fileExtension: file ? file.extension : null,
            fileName: file ? file.name : null,
            participantName,
            participantSigningOrder,
          };
        });
      });
    case DOCUMENT__INITIALIZE:
    case DOCUMENT_ATTACHMENTS__FETCH_FAILURE:
      return initialState;
    default:
      return state;
  }
}
